<svelte:options accessors />

<script lang="ts">
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import PrecioItem from "./components/PrecioItem.svelte";
    import NauiFloatingAction from "../naui/components/NauiFloatingAction.svelte";
    import type { IPrecioItem } from "../interfaces/precio-item.interface";
    import {
        CreatorItemPrice,
        ItemPrice,
    } from "../interfaces/item-price.class";
    import ItemApprove from "./components/ItemApprove.svelte";
    import Approval from "./components/Approval.svelte";
    import NauiFilters from "../naui/components/NauiFilters.svelte";
    import { currency } from "../utils";
    import { createEventDispatcher, onMount } from "svelte";
    import PricesTable from "./components/PricesTable.svelte";
    import SendUpdatePrices from "./components/prices/SendUpdatePrices.svelte";
    // import { text } from "svelte/internal";

    export let list: Array<IPrecioItem> = [];
    export let asTable: boolean = false;
    export let editable: boolean = false;
    export let canApprove: boolean = false;
    export let canTemplate: boolean = false;
    export let filters: Array<any> = [];
    export let modalApp: any;
    export let actionPrices: any;

    // Agrega variables de paginación
    export let currentPage = 1;
    export let itemsPerPage = 10;
    export let nPages = 5;
    let precios: Array<ItemPrice> = [];
    let dispatch = createEventDispatcher();
    let grossMargin = 0;
    let total = 0;
    let itemApprove;
    let approval;

    let itemsPerPageOptions = [10, 50, 100, 150, 200, 250];
    let filterApply = {} 

    const filtered = (evt) => {
        filterApply = JSON.stringify(evt.detail)
        dispatch("filtered", {
                filters: filterApply,
                currentPage: 1,
                itemsPerPage: itemsPerPage
        });
        currentPage = 1
    }; 
    
    // Función para manejar la actualización de la página
    const updatePage = (evt) => {
        currentPage = evt.detail.currentPage;
        dispatch("updatePage", {
                filters: filterApply,
                currentPage: evt.detail.currentPage,
                itemsPerPage: evt.detail.itemsPerPage,
                nPages: evt.detail.nPages
        });

        itemsPerPage = evt.detail.itemsPerPage
    };

    const updatePage1 = (newPage) => {
        currentPage = Math.max(1, Math.min(newPage, Math.ceil(nPages)));
        let data = {
            filters: filterApply,
            currentPage: currentPage,
            itemsPerPage: itemsPerPage,
            nPages: nPages
        }
        dispatch("updatePage", data);

        itemsPerPage = itemsPerPage
     };
     // Lógica adicional para cargar datos de la nueva página, si es necesario

    $: precios = precios;
    $: endIndex = nPages;
    $: currentPage = currentPage;
    $: filterApply = filterApply
    $: itemsPerPage = itemsPerPage




    onMount(() => {
        init();
    });

    export function init() {
        const creator = new CreatorItemPrice();
        precios = (list || []).map((l) => creator.create(l));
    }

    function forceUpdate() {
        precios = [...precios];
    }

    function sendAndKeep(action: string) {
        if (modalApp) {
            const pending = precios.filter(
                (p) => !p.isCompleted && !p.toApprove //En revisión
            );
            const base = pending.filter((p) => p.valid);
            if (base.length === 0) {
                modalApp.openModal({
                    title: 'ATENCIÓN',
                    message: 'Para guardar debe tener al menos un item con precio a ofertar y precio de puja diligenciado.',
                    button: 'ACEPTAR',
                    closeButton: false,
                    closeOnEsc: false,
                    closeOnOuterClick: false
                });
            } else {
                actionPrices.setPrices({
                    hasAlert: base.some((p) => p.hasNewAlert),
                    alert: base.filter((p) => p.hasNewAlert),
                    incomplete: pending.filter((p) => !p.valid),
                    complete: base.filter((p) => !p.hasNewAlert),
                    onAccept: () => {
                        dispatch("pricing", {
                            items: precios
                                .filter((p) => p.enabled)
                                .map((p) => p.toUpdate()),
                            action: action
                        });
                    },
                    onCancel: () => {},
                    action: action
                });
                actionPrices.show();
            }
        } else {
            dispatch("pricing", {
                items: precios
                    .filter((p) => p.enabled)
                    .map((p) => p.toUpdate()),
            });
        }
    }

    function handleApproval(evt) {
        const { id, status } = evt.detail;
        if (itemApprove) {
            itemApprove.$set({
                id,
                status,
                comment: null,
                open: true
            });
        }
    }

    function showApproval(evt) {
        if (approval) {
            approval.$set({
                ...evt.detail,
                open: true,
            });
        }
    };

    function decodeProductTable (evt) {
        dispatch("decodeProduct", {
                items: evt.detail.items,
                message: evt.detail.message
            });
        
    }

    $: pending = precios.filter(p => !p.isCompleted && !p.toApprove).some(p => p.valid);
    $: hasAlert = precios.filter(p => !p.isCompleted && !p.toApprove && p.valid).some(p => p.alert);

    /*
     ** Reactive calc of total and gross margin.
     */
    $: total = precios.reduce<number>((c: number, p: ItemPrice) => {
        c += p.totalValueOffer;
        return c;
    }, 0);
    $: grossMargin = precios.reduce<number>((c: number, p: ItemPrice) => {
        c += p.grossMargin;
        return c;
    }, 0);
</script>

<div class="mb-3">
    <!--
    <code>
        Pendientes por enviar?: {pending} <br>
        Tiene alertas?: {hasAlert}
    </code>
    -->
    <div class="box-b mb-1">
        <div>
            <NauiFilters {filters} on:filtered={filtered}/>
        </div>
        <div class="box-r sx-ii">
            <NauiButton
                icon="list"
                color="primary"
                on:click={() => (asTable = false)}
            />
            <NauiButton
                icon="table"
                color="primary"
                on:click={() => (asTable = true)}
            />
        </div>
    </div>

    {#if asTable}
        <PricesTable {precios} {editable} {modalApp} {currentPage} {itemsPerPage} {itemsPerPageOptions} {nPages}
            on:input={forceUpdate} 
            on:decodeProduct = {decodeProductTable}
            on:updatePage={updatePage}
        />
    {:else}
    
    <div style="display: flex; align-items: center;">
        <!-- Botón Anterior -->
        <div>
            <NauiButton
                size="small"
                caption="Anterior"
                mode="stroked"
                color="accent"
                on:click={() => updatePage1(currentPage - 1)}
                download={currentPage === 1}
            ></NauiButton>
        </div>
    
        <!-- Botón Siguiente -->
        <div style="margin-left: 10px;">
            <NauiButton
                size="small"
                caption="Siguiente"
                mode="stroked"
                color="accent"
                on:click={() => updatePage1(currentPage + 1)}
                download={endIndex >= nPages}
            ></NauiButton>
        </div>
    
        <!-- Contador de páginas -->
        <div style="margin-left: 10px;">
            <p>Página {currentPage} de {nPages}</p>
        </div>
        
        <!-- Select para seleccionar elementos por página -->
        <div style="margin-left: 10px;">
            <label for="itemsPerPageSelect">Items por página:</label>
            <select 
                bind:value={itemsPerPage}
                on:change={() => updatePage1(1)} 
                id="itemsPerPageSelect">
            {#each itemsPerPageOptions as option}
                <option value={option}>{option}</option>
            {/each}
            </select>
        </div>

    </div>
        {#each precios as item (item.id)}
            <PrecioItem
                {item} {currentPage} {itemsPerPage} {itemsPerPageOptions} {nPages}
                on:update={forceUpdate}
                on:input={forceUpdate}
                on:sendApproval={handleApproval}
                on:showApproval={showApproval}
                on:updatePage={updatePage}
                {canApprove}
                {editable}
            />
        {/each}
    {/if}
    <!--
        {#if editable && pending}
            If it's editable we enable to send updates about prices.
            {#if hasAlert}
                <div class="box-l sx-ii alert-ga shadow radius">
                    <i class="far fa-exclamation-triangle"></i>
                    <b>ATENCIÓN:</b>
                    <div>
                        Existen precios dentro de la propuesta que se encuentran por debajo del mínimo aprobado por la
                        división,
                        o por debajo del costo. Esta propuesta será enviada a revisión por parte del gerente de división
                        o
                        gerente general, según corresponda.
                    </div>
                    <div style="min-width: 200px">
                        <NauiButton caption="ENVIAR A REVISIÓN"
                                    color="accent"
                                    mode="outline"
                                    on:click={()=>save()}/>
                    </div>
                </div>
            {:else}
                <div class="box-r">
                    <NauiButton icon="save"
                                caption="GUARDAR"
                                color="accent"
                                mode="solid"
                                on:click={()=>save()}/>
                </div>
            {/if}

        {/if}
    -->
    {#if canTemplate}
        <div class="box-r">
            <NauiButton
                caption="GENERAR PLANTILLA"
                color="accent"
                mode="solid"
                on:click={() => dispatch("plantilla")}
            />
        </div>
    {/if}
</div>
<NauiFloatingAction left={true}>
    <div class="box-l total-box">
        <div class="total-box-title">Total oferta Unidad de Negocio</div>
        <div class="box-l px-1 py-i my-i total-border">
            <div class="mr-1">Valor Total</div>
            <div>{currency.format(total)}</div>
        </div>
        <div class="box-l px-1 py-i my-i">
            <div class="mr-1">Margen bruto</div>
            <div>{currency.format(grossMargin)}</div>
        </div>

        <ItemApprove bind:this={itemApprove} on:send />

        <Approval bind:this={approval} />

        <SendUpdatePrices bind:this={actionPrices} />
    </div>
</NauiFloatingAction>

{#if editable}
    <NauiFloatingAction>
        <NauiButton caption="GUARDAR"
            icon="save"
            color="accent"
            mode="solid"
            on:click={()=>sendAndKeep("Guardar")}/>

        <NauiButton caption="ENVIAR"
            icon="save"
            color="primary"
            mode="solid"
            on:click={() => sendAndKeep("Enviar")}/>
    </NauiFloatingAction>
{/if}


<!-- <ItemApprove bind:this={itemApprove} on:send />

<Approval bind:this={approval} />

<SendUpdatePrices bind:this={actionPrices} /> -->
<style>
    .total-box {
        margin-right: 5rem;
        background-color: #fafafa;
        color: #555555 !important;
        font-size: 15px;
    }

    .total-box-title {
        background-color: #04aa7c;
        color: #ffffff;
        padding: 0.75rem 1rem;
    }

    .total-border {
        border-right: 1px solid #dfe1e5;
    }
</style>
